export const preferenceKeys = {
    userProfile: `userProfile`,
    authToken: `authToken`,
    deviceToken: `DeviceToken`,
    secondaryProfile: `secondaryProfile`,
    tempUserData: "tempUserData",
    tempId: "tempId",
};
